<template>
    <div class="biz-view-employee-role-page">
        <view-employee-role-comp :class="{'fixed': listIsFixed}"></view-employee-role-comp>
    </div>
</template>
<script>
import bizBreadcrumb from '@/components/bussiness/widges/tools/bizBreadcrumb.vue';
import viewEmployeeRoleComp from '@/components/bussiness/internalAuth/employeeRole/viewEmployeeRoleComp.vue';

export default {
    data () {
        return {
            listIsFixed: false
        }
    },
    mounted () {
        window.addEventListener('scroll', this.handleScroll);
    },
    destroyed() {
        window.removeEventListener('scroll', this.handleScroll);
        document.getElementsByClassName('biz-tool-bar-wrap')[0].style.display = 'flex'
    },
    methods: {
        handleScroll: function () {
            let scrollTop = event.target.documentElement.scrollTop
            // console.log(scrollTop)
            if( scrollTop >= 50){
                document.getElementsByClassName('biz-tool-bar-wrap')[0].style.display = 'none'
                document.getElementsByClassName('page-header')[0].style.zIndex = '8'
            }else{
                document.getElementsByClassName('biz-tool-bar-wrap')[0].style.display = 'flex'
                document.getElementsByClassName('page-header')[0].style.zIndex = '8'
                this.listIsFixed = false
            }

            if( scrollTop >= 115){
                this.listIsFixed = true
            }
        },
    },
    components: {
        bizBreadcrumb,
        viewEmployeeRoleComp
    }
}
</script>
<style lang="scss" scoped>
    .biz-view-employee-role-page{
        position: relative;
    }
</style>


// WEBPACK FOOTER //
// src/pages/bussiness/internalAuth/employeeRole/viewEmployeeRole.vue